import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { blueSpringsMOConfig } from "./data";

export default function BlueSpringsPage() {
  return <CityPageTemplate config={blueSpringsMOConfig} />;
}